import { Box, Button, Typography, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';

function BlockIcon({ size = 48 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
      <line
        x1="5.6"
        y1="5.6"
        x2="18.4"
        y2="18.4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function BlockedState({
  email: _email,
  domain,
  onBack,
}: {
  email: string;
  domain: string;
  onBack: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Box data-testid="login-blocked-state" sx={{ textAlign: 'center' }}>
      <Box sx={{ color: 'error.main', mb: 1, display: 'inline-flex' }}>
        <BlockIcon size={48} />
      </Box>
      <Typography variant="h5" component="h1" sx={{ fontWeight: 600, mb: 1 }}>
        {t('login.blocked.title')}
      </Typography>
      <Alert
        severity="warning"
        sx={{ textAlign: 'left', mb: 3 }}
        data-testid="login-blocked-message"
      >
        {t('login.blocked.lede', { domain })}
      </Alert>
      <Button
        variant="text"
        onClick={onBack}
        data-testid="login-blocked-back"
        sx={{ textTransform: 'none' }}
      >
        {t('login.blocked.back')}
      </Button>
    </Box>
  );
}
